import { Fragment } from "react"

import Modal from "./Modal"
import { useModals } from "web/hooks/modals"

export default function ModalContainer() {
  const { modals, clearModal } = useModals()

  return modals.map(({ key, ...rest }, i) => {
    const containerZIndex = 50 + i * 2
    const modalZIndex = containerZIndex + 1

    return (
      <Fragment key={key}>
        <div className="modal-container" style={{ zIndex: containerZIndex }} />
        <Modal
          modalKey={key}
          onClose={clearModal}
          zIndex={modalZIndex}
          {...rest}
        />
      </Fragment>
    )
  })
}
